import { NgModule } from '@angular/core';
import { NotificationsComponent } from './notifications.component';
import { CommonModule } from '@angular/common';
import { EdAssistUIModalModule } from '@edassist-ui/modal';
import { EdAssistUISliderModule } from '@edassist-ui/slider';
import { EdAssistUIIconModule } from '@edassist-ui/icon';
import { ApplicationEventNotificationModule } from './application/application-event-notification.module';
import { EdAssistUIHeadingModule } from '@edassist-ui/heading';
import { EdAssistUILoadingContainerModule } from '@edassist-ui/loading-container';
import { NotificationsSliderComponent } from './slider/notifications-slider.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AnnouncementModule } from './announcement/announcement.module';
import { ReviewApplicationAppealModule } from './review-application-appeal/review-application-appeal.module';
import { EmailModule } from './email/email.module';
import { EdAssistUIButtonLinkModule } from '@edassist-ui/button-link';
import { EdAssistUIInputDropdownModule } from '@edassist-ui/input-dropdown';
import { EdAssistUIFormsModule } from '@edassist-ui/forms';
import { EdAssistUIDropdownIconItemModule } from '@edassist-ui/dropdown-icon-item/dropdown-icon-item.module';

@NgModule({
	declarations: [NotificationsComponent, NotificationsSliderComponent],
	imports: [
		CommonModule,
		EdAssistUIModalModule,
		EdAssistUISliderModule,
		EdAssistUIIconModule,
		ApplicationEventNotificationModule,
		EdAssistUIHeadingModule,
		EdAssistUILoadingContainerModule,
		InfiniteScrollModule,
		AnnouncementModule,
		ReviewApplicationAppealModule,
		EmailModule,
		EdAssistUIButtonLinkModule,
		EdAssistUIInputDropdownModule,
		EdAssistUIFormsModule,
		EdAssistUIDropdownIconItemModule
	],
	exports: [NotificationsComponent, NotificationsSliderComponent]
})
export class NotificationsModule {}
